// some browsers cut a download whose address is revoked at once
const REVOKE_DELAY_MS = 60 * 1000;

export const getAttachmentFileName = (contentDisposition: string | undefined, fallback: string): string => {
  const match = contentDisposition?.match(/filename="([^"]+)"/);
  return match ? match[1] : fallback;
};

export const saveBlob = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS);
};
